<div>
	@if (rotor) {
		<div class="row">
			<label class="col-md-2 col-form-label-sm">Operation:</label>
			<div class="col-md-6">
				@if (operations !== undefined) {
					<select class="form-control form-control-sm op-list" [(ngModel)]="operation" (ngModelChange)="refreshRegimeCounts()"
						[title]="operations | operationslimitnote : 'track' : rotor.rotorid">
						@for (operation of operations; track operation) {
							<option [ngValue]="operation" [class]="GetOpClass(operation)">
								{{operation | operationlabel : (fleet ? fleet.time_offset_hours : 0) : true}}
							</option>
						}
					</select>
				}
				@if (operations === undefined) {
					<select class="form-control form-control-sm" disabled>
						<option>Loading Track operations...</option>
					</select>
				}
			</div>
		</div>
	}

	@if (regimeCounts !== undefined && regimeCounts.length === 0) {
		<div class="loading-status">
			No track data is available for the selected operation
		</div>
	}

	@if (operations && operations.length > 0 && regimeCounts === undefined) {
		<div class="loading-status">
			<div class="logo-spin"></div>
			Loading track operations...
		</div>
	}

	@if (operations && operations.length === 0) {
		<div class="loading-status">
			No operations with track data are available
		</div>
	}

	@if (regimeCounts !== undefined && regimeCounts.length > 0) {
		<div class="row">
			<div class="col-lg-5">
				<app-regime-list [regimes]="regimeCounts" evaluateHeader="Eval" [extraColumns]="2" (evaluateChange)="regimesChange()">
					<ng-template #regimeHeaderCells>
						<th>Split ({{rotor.inches ? "in" : "mm"}})</th>
						<th>Pred ({{rotor.inches ? "in" : "mm"}})</th>
					</ng-template>
					<ng-template #regimeRowCells let-regime>
						<td>
							@if (regimeSplit) {
								<span>{{regimeSplit[regime.regime_id]?.split | number : (rotor.inches ? "1.0-2" : "1.0-1")}}</span>
							}
						</td>
						<td>
							@if (regimeSplit) {
								<span>{{regimeSplit[regime.regime_id]?.predsplit | number : (rotor.inches ? "1.0-2" : "1.0-1")}}</span>
							}
						</td>
					</ng-template>
				</app-regime-list>
				@if (rotor.balancedata && rotor.balancedata.numblades >= 4 && !rotor.balancedata.oneperrev) {
					<app-shaft-order [showShaftOrder]="false" [showOneRev]="true" [(oneRevOnly)]="onePerRevOnly" (refresh)="updatePlot()"></app-shaft-order>
				}
				@if (selectedRegimes && selectedRegimes.length) {
					<div class="panel mt-3">
						<div class="heading">Adjustments</div>
						<div class="content">
							<!-- Note: configs with extra blades in displaygroups are "guaranteed" to not use track -->
							<app-adjustment-grid [rotor]="rotor" [adjustments]="adjustments" [alternates]="alternates" [adjDetail]="adjDetail"
								[adjustmentSelect]="adjustmentSelect" [reorderHeaderForClockwise]="true" [excludeWts]="true" (enter)="ManualAdjustment()"
								(selectChange)="updatePlot()" (alternateSelect)="SetAdjustment($event.row, $event.alt)"></app-adjustment-grid>
							<button (click)="RecordAdjustment()" class="button block">Record adjustment</button>
						</div>
					</div>
				}
			</div>
			<div class="col-lg-7">
				<app-dvs-chart #chart [error]="errormessage" [options]="trackOptions" loading="Loading track data..." [height]="'400px'"></app-dvs-chart>
				@if (trackOptions) {
					<div class="chart-legend">
						<span #avgLegend class="legend-item interactive" (click)="togglePointVisible('Current Track')" (mouseenter)="setPointHover('Current Track', true)"
							(mouseleave)="setPointHover('Current Track', false)">
							<span class="swatch square"></span> Averages
						</span>
						<span #predLegend class="legend-item interactive" (click)="togglePointVisible('Predicted Track')" (mouseenter)="setPointHover('Predicted Track', true)"
							(mouseleave)="setPointHover('Predicted Track', false)">
							<span class="swatch diamond"></span> Predictions
						</span>
					</div>
				}
			</div>
		</div>
	}
</div>